import * as React from 'react';
import styled from 'styled-components';
import CloudsImg from '../../static/images/workday/clouds.svg';
import MagnifyingLens from '../../static/images/workday/magnifyingLens.svg';
import { Button } from '../Button/Button';
import { MouseParallaxIcon } from '../Icon/MouseParallaxIcon';
import { Typography } from '../Typography/Typography';
import { useIntlUds } from '../../translations/UdsIntlProvider';

export interface EmptyResultsProps {
  message?: string;
  height?: number;
  width?: number;
  className?: string;
  buttonConfig?: { label: string; callback: () => void };
  backgroundImgUrl?: any;
  foregroundImgUrl?: any;
}

export const EmptyResults: React.FC<React.PropsWithChildren<EmptyResultsProps>> = ({
  height,
  width,
  className,
  message,
  buttonConfig,
  backgroundImgUrl,
  foregroundImgUrl
}) => {
  const { intl } = useIntlUds();

  return (
    <StyledEmptyContainer data-test="empty-results" className={className} $height={height || 200} $width={width || 300}>
      <MouseParallaxIcon
        height={height || 200}
        width={width || 300}
        backgroundImgUrl={backgroundImgUrl ?? CloudsImg}
        foregroundImgUrl={foregroundImgUrl ?? MagnifyingLens}
      />
      <StyledMessage>{message ?? intl.EmptyResults.message}</StyledMessage>
      {buttonConfig && (
        <StyledActionButton
          dataTest="empty__result__action__button"
          children={buttonConfig.label}
          variant="contained"
          color="primary"
          onClick={buttonConfig.callback}
          key="confirm"
          size="medium"
        />
      )}
    </StyledEmptyContainer>
  );
};

const StyledActionButton = styled(Button)`
  margin-top: 1.5rem;
  min-height: 2.4rem !important;
  pointer-events: ${(props) => (props?.disabled ? 'none' : 'auto')} !important;
`;

const StyledEmptyContainer = styled.div<{ $height: number; $width: number }>`
  flex: 1 1 auto;
  height: ${({ $height }) => $height}px;
  width: ${({ $width }) => $width}px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    padding-top: 1rem;
  }
`;

const StyledMessage = styled(Typography)`
  && {
    margin-top: 1rem;
  }
`;

export default EmptyResults;
